module.exports = __webpack_public_path__ + "static/jamiejones-d51c376aa9cb64ca1c5df207344d98c4.jpg";